import { render, staticRenderFns } from "./GrillaItem.vue?vue&type=template&id=6e72d04a"
import script from "./GrillaItem.vue?vue&type=script&lang=js"
export * from "./GrillaItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports